function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.75 1.25H1.25C.5 1.25 0 1.75 0 2.5v1.75l10 5.625 10-5.5V2.5c0-.75-.5-1.25-1.25-1.25z",
  fill: "#47C5F3"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.375 12.375L0 7.125V17.5c0 .75.5 1.25 1.25 1.25h17.5c.75 0 1.25-.5 1.25-1.25V7.125l-9.375 5.25c-.35.175-.9.175-1.25 0z",
  fill: "#47C5F3"
});

function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xOC43NSAxLjI1SDEuMjVDMC41IDEuMjUgMCAxLjc1IDAgMi41VjQuMjVMMTAgOS44NzVMMjAgNC4zNzVWMi41QzIwIDEuNzUgMTkuNSAxLjI1IDE4Ljc1IDEuMjVaIiBmaWxsPSIjNDdDNUYzIi8+CjxwYXRoIGQ9Ik05LjM3NSAxMi4zNzVMMCA3LjEyNVYxNy41QzAgMTguMjUgMC41IDE4Ljc1IDEuMjUgMTguNzVIMTguNzVDMTkuNSAxOC43NSAyMCAxOC4yNSAyMCAxNy41VjcuMTI1TDEwLjYyNSAxMi4zNzVDMTAuMjc1IDEyLjU1IDkuNzI1IDEyLjU1IDkuMzc1IDEyLjM3NVoiIGZpbGw9IiM0N0M1RjMiLz4KPC9zdmc+Cg==";
export { SvgEmail as ReactComponent };